var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "treatment-add-on",
      class: { "--selected": _vm.addOnIsSelected },
    },
    [
      _c("div", { staticClass: "treatment-add-on__header" }, [
        _c("span", { staticClass: "treatment-add-on__name" }, [
          _vm._v(_vm._s(_vm.addOn.name)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "treatment-add-on__price" }, [
          _vm._v("USD $20"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "treatment-add-on__description" }, [
        _vm._v("\n    " + _vm._s(_vm.addOn.description) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "treatment-add-on__action" }, [
        _vm.addOnIsSelected
          ? _c(
              "button",
              {
                staticClass: "treatment-add-on__button--remove",
                on: { click: _vm.handleRemoveClick },
              },
              [_c("span", { staticClass: "icon-close" })]
            )
          : _c(
              "button",
              {
                staticClass: "treatment-add-on__button--add",
                on: { click: _vm.handleAddClick },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.tc("spaSoft.step1.selectedTreatments.addTreatment")
                    ) +
                    "\n    "
                ),
              ]
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }